// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textarea{resize:none;padding:.375rem .75rem}`, "",{"version":3,"sources":["webpack://./src/common/components/form/textarea/textarea.scss"],"names":[],"mappings":"AAAA,UACE,WAAA,CACA,sBAAA","sourcesContent":[".textarea {\n  resize: none;\n  padding: .375rem .75rem\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
